import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Row, Col } from 'antd'
import _ from 'lodash'
import { devicePay, intl } from 'utils'
import DevicePay from 'components/PaymentMethods/DevicePay'
import WhiteSpace from 'components/WhiteSpace'
import PaymentMethodIcon from 'components/PaymentMethodIcon'
import messages from '../PaymentMethodButton/messages'

export default class PaymentMethodSelector extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      selectedIndex: 0,
    }
  }

  handleClick = (index) => {
    this.setState({
      selectedIndex: index
    })
    this.props.onSelect(`${index}`)
  }

  componentDidMount = async () => {
    if (this.props.data && !_.isEqual(this.state.data, this.props.data)) {
      const data = await devicePay.filter(_.clone(this.props.data))
      const preferred = _.find(data, devicePay.preferred())
      preferred && _.remove(data, preferred)
      this.setState({
        data,
        preferred
      })
    }
  }

  render() {
    const { data, preferred } = this.state
    const { orderLabel } = this.props
    return (
      <React.Fragment>
        {preferred && (
          <div>
            <DevicePay
              actions={this.props.actions}
              item={preferred}
              siteConfig={this.props.siteConfig}
              submit={this.props.submit}
              orderLabel={orderLabel}
            />
            <WhiteSpace size='xl' />
          </div>
        )}

        <div className={classes.componentsPaymentMethodSelector}>
          {data.map((item, index) => {
            const selected = this.state.selectedIndex === index
            if (item.tabType === 'MESSAGE_PAY') {
              return null
            }
            return (
              <Row
                key={item.tabName}
                className={selected ? classes.selected : ''}
                onClick={() => this.handleClick(index)}
              >
                <Col span={22}>
                  <PaymentMethodIcon height={24} {...item} />
                  <b>{item.tabType === 'PAY_METHODS' && item.tabName === 'Card Pay'
                    ? intl().formatMessage(messages.bankCard)
                    : item.tabName !== 'AliPay'
                      ? item.tabName
                      : null}
                  </b>
                </Col>
                <Col span={2}>
                  {selected && (
                    <span className={`pull-right ${classes.chooseIcon}`}>
                      <span className='iconfont iconcomm-choose white' />
                    </span>
                  )}
                </Col>
              </Row>
            )
          })}
        </div>
      </React.Fragment>
    )
  }
}
